import _regeneratorRuntime from "/builds/twentythousand/browser-client/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/twentythousand/browser-client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
 * Default buffer size
 */
var DEFAULT_BUFFER_SIZE = 5;
/*
 * Default flush timeout
 */

var DEFAULT_FLUSH_TIMEOUT = 1000;
/**
 * batch the buffer coming in, process them and then resolve
 *
 * @param size - Number
 * @param flushTimeout - Number
 */

export default function makeBatch() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BUFFER_SIZE;
  var flushTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLUSH_TIMEOUT;
  var timeout;
  var cb;
  var buffer = [];
  /*
   * Process then flush the list
   */

  function flush() {
    return _flush.apply(this, arguments);
  }
  /*
   * Start timeout to flush
   */


  function _flush() {
    _flush = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var currentBuffer;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (timeout) {
                clearTimeout(timeout);
              }

              timeout = null;
              currentBuffer = buffer;
              buffer = [];
              _context3.prev = 4;
              _context3.next = 7;
              return cb(currentBuffer.map(function (d) {
                return d.log;
              }));

            case 7:
              currentBuffer.forEach(function (d) {
                return d.resolve(d.log);
              });
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);
              currentBuffer.map(function (d) {
                return d.reject(_context3.t0);
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 10]]);
    }));
    return _flush.apply(this, arguments);
  }

  function setupTimeout() {
    return _setupTimeout.apply(this, arguments);
  }
  /*
   * Batcher which takes a process function
   * @param fn - Any function to process list
   */


  function _setupTimeout() {
    _setupTimeout = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!timeout) {
                timeout = setTimeout(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return flush();

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), flushTimeout);
              }

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _setupTimeout.apply(this, arguments);
  }

  return function (fn) {
    cb = fn;
    /*
     * Pushes each log into list
     * @param log: ITimberLog - Any object to push into list
     */

    return (
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(log) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", new Promise(
                  /*#__PURE__*/
                  function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee(resolve, reject) {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              buffer.push({
                                log: log,
                                resolve: resolve,
                                reject: reject
                              });

                              if (!(buffer.length >= size)) {
                                _context.next = 6;
                                break;
                              }

                              _context.next = 4;
                              return flush();

                            case 4:
                              _context.next = 8;
                              break;

                            case 6:
                              _context.next = 8;
                              return setupTimeout();

                            case 8:
                              return _context.abrupt("return", resolve);

                            case 9:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()));

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()
    );
  };
}